import { createSlice } from "@reduxjs/toolkit"

export const Token = createSlice({
    name: "token",
    initialState: {
        tokenID: ""
    },
    reducers: {
        TokenAction: (state, action) => {
            state.tokenID = action.payload
        },
    }
})

export const { TokenAction } = Token.actions;

export default Token.reducer;